import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-treasury-check`;

export const ResendClaimButton = ({ check, token, onDone }) => {
  const [busy, setBusy] = useState(false);
  if (!check.can_resend_claim) return null;
  const expired = new Date(check.claim_expires_at) < new Date();
  const resend = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/checks/${check.check_id}/resend-claim`, {}, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(r.data.message); onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not resend the claim link'); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-3 text-sm" data-testid="resend-claim-box">
      <span className={expired ? 'text-amber-300' : 'text-slate-400'} data-testid="claim-expiry-status">
        Claim link {expired ? 'expired' : 'valid until'} {new Date(check.claim_expires_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
      </span>
      <button onClick={resend} disabled={busy} data-testid="resend-claim-btn"
        className="px-3 py-1.5 border border-emerald-600 text-emerald-400 rounded-lg flex items-center gap-2 hover:bg-emerald-600/10 disabled:opacity-50">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Resend claim link
      </button>
    </div>
  );
};
